module.exports = __webpack_public_path__ + "media/product/instagram-4-84884688.jpg";